import { ConfigService } from 'vimmi-web-utils/cjs/configService';

const config = new ConfigService();
config.set({
  debug: false,
  params: {//params parsed from query string and merged with back-end params
    lang: 'en'
  },
  keySystemsFullList: {
    'DASH/WIDEVINE': ['com.widevine.alpha'],
    'DASH/PLAYREADY': ['com.microsoft.playready', 'com.youtube.playready'],
    clearkey: ['webkit-org.w3.clearkey', 'org.w3.clearkey'],
    primetime: ['com.adobe.primetime', 'com.adobe.access'],
    'HLS/FAIRPLAY': ['com.apple.fairplay']
  },
  keySystems: {
    // 'DASH/WIDEVINE':'',
    'DASH/PLAYREADY': 'com.microsoft.playready',
    'DASH/WIDEVINE': 'com.widevine.alpha',
    'HLS/FAIRPLAY': 'com.apple.fps.1_0'
  },
  eventsState: {
    isStartPlay: false,
    prevUserActiveState: false,
    loadstart: false,
    waiting: false,
    loadedmetadata: false,
    loadeddata: false,
    ended: false,
    error: false
  },
  supportTypes: {
    m3u8: 'application/x-mpegURL',
    mpd: 'application/dash+xml',
    mp4: 'video/mp4',
    fm3u8: 'application/vnd.apple.mpegurl', //means hls/fairplay
    default: 'application/x-mpegURL'
  },
  EmbeddedCodeOpt: {
    height: 337.5,
    width: 600
  },
  vjsOptions: {
    width: '50%',
    height: '50%',
    language: 'en',
    textTrackSettings: true,
    preferFullWindow: false, // https://videojs.com/guides/options/#preferfullwindow
    persistTextTrackSettings: true,
    // userActions: {
    //   click: false
    // }
    // plugins: {
    //   eme: {}
    // },
    html5: {
      vhs: {
        overrideNative: true,
        handleManifestRedirects: true,
        maxPlaylistRetries: 2,
        bandwidth: 1200000,
        enableLowInitialPlaylist: false,
        limitRenditionByPlayerDimensions: true,
        // handlePartialData: true,
        useDevicePixelRatio: true,
        fastQualityChange: true
      },
      nativeAudioTracks: false,
      nativeVideoTracks: false,
      nativeCaptions: false,
      nativeTextTracks: false
    }
  }
});
export default config;